import { render } from "./users-item.vue?vue&type=template&id=6616d6b8"
import script from "./users-item.vue?vue&type=script&lang=js"
export * from "./users-item.vue?vue&type=script&lang=js"

import "./users-item.vue?vue&type=style&index=0&id=6616d6b8&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__